module.exports = __webpack_public_path__ + "static/media/Price1499Adv.5ee2baf8.svg";